




























































































































import { Vue, Component } from "vue-property-decorator";
import { Observer } from "mobx-vue";
import requestStore from "@/store/requestStore";
import { RequestModel, RequestTaskModel, isTaskComplete } from "@/api/Requests";
import RequestTaskStatusIcon from "./RequestTaskStatusIcon.vue";
import RequestStatusIcon from "./RequestStatusIcon.vue";
import RequestCancelDialog from "./RequestCancelDialog.vue";
import notificationStore from "@/store/notificationStore";
import { reaction } from "mobx";
import { dateExact, timeExact } from "@/filters/DateExact";

@Observer
@Component({ components: { RequestTaskStatusIcon, RequestStatusIcon, RequestCancelDialog } })
class RequestList extends Vue {
  requestStore = requestStore;

  expandedRows: RequestModel[] = [];
  dispose?: () => void;

  //I need to have a local variable like this to toggle the show/hide instead of using this.requestStore.RequestCancelDialogOpen
  //Otherwise it takes 2 times for the popup to show and the popup won't hide
  requestCancelDialogOpen = false;

  headers = [
    { text: "Status", value: "status" },
    { text: "Request Id", value: "requestSerialId" },
    { text: "Request Type", value: "requestType" },
    { text: "Reference Number", value: "councilReferenceNumber" },
    { text: "Number", value: "addressStreetNoDisplay" },
    { text: "Street", value: "addressStreetName" },
    { text: "Suburb", value: "addressSuburbName" },
    { text: "State", value: "addressStateCode" },
    { text: "Postcode", value: "addressPostCode" },
    { text: "Assessment Number", value: "assessmentNumber" },
    { text: "Created", value: "requestedAt" },
    { text: "Completed", value: "completedAt" },
    { text: "Action", value: "action" },
    { text: "", value: "data-table-expand" }
  ];

  exportLoading = false;

  mounted() {
    reaction(
      () => this.requestStore.loading.isInProgress("exportToXlsx"),
      isLoading => {
        this.exportLoading = isLoading;
      },
      { fireImmediately: true }
    );

    const requestCancelDialogOpenHandler = reaction(
      () => this.requestStore.RequestCancelDialogOpen,
      () => {
        this.requestCancelDialogOpen = this.requestStore.RequestCancelDialogOpen;
      },
      { fireImmediately: true }
    );

    const enableCreateRequestHandler = reaction(
      () => this.requestStore.enableCreateRequest,
      () => {
        if (this.requestStore.enableCreateRequest) {
          if (!this.headers.some(h => h.text == "Action")) {
            this.headers.splice(12, 0, { text: "Action", value: "cancel" });
          }
        } else {
          if (this.headers.some(h => h.text == "Action")) {
            this.headers.splice(12, 1);
          }
        }
      },
      { fireImmediately: true }
    );

    this.dispose = () => {
      enableCreateRequestHandler();
      requestCancelDialogOpenHandler();
    };
  }

  taskHeaders = [
    { text: "Status", value: "status" },
    { text: "Name", value: "taskName" },
    { text: "Waste Stream", value: "wasteStream" },
    { text: "Bin Size", value: "binSize" },
    { text: "Bin Count", value: "binCount" },
    { text: "Scheduled", value: "scheduledDate" },
    { text: "Completed", value: "performedAt" },
    { text: "Old Bin Serial", value: "oldBinSerialNumber" },
    { text: "New Bin Serial", value: "newBinSerialNumber" },
    { text: "More Information", value: "moreInformation" },
    { text: "Reason", value: "statusReason" },
    { text: "Run", value: "runId" }
  ];

  requestCompletedAt(item: RequestModel) {
    if (item.tasks.length === 0) return null;
    if (!item.tasks.every(t => isTaskComplete(t))) return null;

    // Find the latest performedAt, return as ISO string
    const latest = item.tasks
      .map(t => t.performedAt)
      .filter(Boolean)
      .sort()
      .reverse()[0];
    return latest || null;
  }

  hasInProgressNotes(items: RequestTaskModel[]): boolean {
    return items.some(item => item.inProgressNotes);
  }

  getInProgressNotes(items: RequestTaskModel[]): string {
    return items.map(task => task.inProgressNotes).join(";");
  }

  formatDateExact(value: string | Date | null) {
    if (!value) return "";
    const iso = value instanceof Date ? value.toISOString() : value;
    return dateExact(iso);
  }

  formatTimeExact(value: string | Date | null) {
    if (!value) return "";
    const iso = value instanceof Date ? value.toISOString() : value;
    return timeExact(iso);
  }

  async displayCancelRequestOptions(item: RequestModel) {
    requestStore.cancelItemSelected = item;
    requestStore.RequestCancelDialogOpen = true;
  }

  async cancelRequest() {
    if (requestStore.cancelItemSelected == null) {
      return;
    }

    try {
      await requestStore.CancelRequest(requestStore.cancelItemSelected.requestId);
      await requestStore.fetchRequests(); // Refresh the requests list with current filters after cancellation
      notificationStore.success("Request Cancelled");
    } catch (error) {
      notificationStore.error("An unexpected error occurred while cancelling the request. Please try again later or contact support.");
    }
    requestStore.cancelItemSelected = null;
    requestStore.RequestCancelDialogOpen = false;
  }

  onRowClicked(item: RequestModel) {
    const index = this.expandedRows.indexOf(item);
    if (index !== -1) {
      this.expandedRows.splice(index, 1);
    } else {
      this.expandedRows.push(item);
    }
  }

  destroyed() {
    if (this.dispose) this.dispose();
  }
}

export default RequestList;
